var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.selectedPricingPlan.renewal_info)?_c('p',{staticClass:"checkout-form-text"},[_vm._v(" "+_vm._s(_vm.$t('checkout.terms'))+" "),_c('a',{attrs:{"href":_vm.link + '/terms.phtml',"target":"_blank"}},[_vm._v(_vm._s(_vm.$t('checkout.terms_link')))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }